import { useAppSelector } from './useAppSelector';
import * as settingsSlice from '../data/settings.slice';
import { isInvalidNoLoadTime } from '../utils/timestampValidation';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type isInvalidNoLoadTimeArgs = Parameters<typeof isInvalidNoLoadTime>;

export const useIsInvalidNoLoadTime = (): ((
  noLoadDateTime: isInvalidNoLoadTimeArgs[0],
  onSiteDateTime: isInvalidNoLoadTimeArgs[1],
  pickupDueDateTime: isInvalidNoLoadTimeArgs[2],
) => {
  isInvalid: boolean;
  errorMessage: string;
}) => {
  const { t } = useTranslation('common');
  const globalSetting = useAppSelector(settingsSlice.selectSingleGlobalSetting);

  const noLoadMinWaitTime = useMemo(() => {
    if (
      globalSetting?.ApplicationSetting?.applicationSettingBC !==
      'NO_LOAD_MINIMUM_WAIT_MINUTES'
    ) {
      return undefined;
    }

    if (globalSetting?.applicationGlobalSettingState !== 'active') {
      return undefined;
    }

    const parsedValue = parseInt(globalSetting?.applicationSettingValue);

    return !Number.isNaN(parsedValue) ? parsedValue : undefined;
  }, [globalSetting]);

  return (noLoadDateTime, onSiteDateTime, pickupDueDateTime) => {
    const isInvalid = isInvalidNoLoadTime(
      noLoadDateTime,
      onSiteDateTime,
      pickupDueDateTime,
      noLoadMinWaitTime,
    );

    return {
      isInvalid,
      errorMessage: t('needsAttention.noLoadTimeBeforeOnSite', {
        noLoadMinWaitTime: noLoadMinWaitTime || 10,
      }),
    };
  };
};
